// Typed route meta via declaration merging (vue-router's documented pattern) —
// avoids an `as` cast at every `to.meta.requiresRole` read site.
declare module 'vue-router' {
  interface RouteMeta {
    /** Roles allowed to enter this route; undefined/omitted = open to any authenticated role. */
    requiresRole?: string[]
  }
}

/**
 * Roles permitted to reach the user-administration screens. Shared by the route
 * gate (`routes/admin.ts`) and the sidebar entry (`MainMenuConfig.ts`) so the
 * two cannot drift: gating only the route leaves a live menu item that bounces
 * the user to the dashboard, which reads as a broken app rather than a denial.
 */
export const USER_ADMIN_ROLES = ['super_admin']

// Pure role-gate predicate, extracted so it is unit-testable without a router.
// `requiredRoles` comes from a route's meta.requiresRole; undefined = open.
export function isRoleAllowed(requiredRoles: string[] | undefined, role: string): boolean {
  if (!requiredRoles || requiredRoles.length === 0) return true
  return requiredRoles.includes(role)
}
